import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Show {
    constructor() {
        this.initTaxatie();
        this.stepSlider();
    }

    initTaxatie() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            },
        });
    }

    stepSlider() {
        new Swiper('#stepSlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 80,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".step-arrows .right",
                prevEl: ".step-arrows .left",
            },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                }
            }
        });
    }
}
